/**
 * Small client for the Absence Compliance API (/api/v1/attendance/pending-absence).
 * Unlike getApi/postApi it keeps the server's error message, so screens can show why an
 * action was refused (e.g. "The deadline has passed").
 */
import { getHeaders } from "./apiHelper";
import { pendingAbsenceUrl } from "./apiRoutes";

export class PendingAbsenceApiError extends Error {
  constructor(message, status) {
    super(message);
    this.name = "PendingAbsenceApiError";
    this.status = status;
  }
}

/** '?a=1&b=2' from an object, skipping empty values. */
export function buildQuery(params = {}) {
  const parts = Object.keys(params)
    .filter(
      (key) =>
        params[key] !== undefined && params[key] !== null && params[key] !== ""
    )
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
    );
  return parts.length > 0 ? `?${parts.join("&")}` : "";
}

async function request(method, path, { query, body } = {}) {
  const url = pendingAbsenceUrl(path) + buildQuery(query);
  const init = {
    method,
    headers: body === undefined ? getHeaders() : getHeaders(false),
  };
  if (body !== undefined) init.body = JSON.stringify(body);

  let response;
  try {
    response = await fetch(url, init);
  } catch (error) {
    throw new PendingAbsenceApiError(
      "Cannot reach the server. Please check your connection and try again."
    );
  }

  let json = null;
  try {
    json = await response.json();
  } catch (error) {
    json = null;
  }

  if (!response.ok) {
    throw new PendingAbsenceApiError(
      (json && json.message) || `The request failed (${response.status}).`,
      response.status
    );
  }
  return json ? json.data : null;
}

export const pendingAbsenceApi = {
  get: (path, query) => request("GET", path, { query }),
  post: (path, body) => request("POST", path, { body }),
  put: (path, body) => request("PUT", path, { body }),
  delete: (path) => request("DELETE", path),
};
